"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCalendarTimezone = exports.getMeetingPlace = exports.getMeetingLimits = exports.getMeetingFrequency = exports.getBufferTimeInMinutes = exports.getMeetingDuration = exports.getIsAutoSendMeetingInvite = exports.getIsHideBusyPeriods = exports.getCalendarPeriods = exports.getCurrencyId = exports.getCountryId = exports.getIsUnsubscribed = exports.getErrors = exports.getIsLoaded = exports.getIsLoading = void 0;

var _ramda = require("ramda");

var pathToProfileSettings = (0, _ramda.prop)('personalProfileSettings');
var getIsLoading = (0, _ramda.compose)((0, _ramda.prop)('isLoading'), pathToProfileSettings);
exports.getIsLoading = getIsLoading;
var getIsLoaded = (0, _ramda.compose)((0, _ramda.prop)('isLoaded'), pathToProfileSettings);
exports.getIsLoaded = getIsLoaded;
var getErrors = (0, _ramda.compose)((0, _ramda.prop)('errors'), pathToProfileSettings);
exports.getErrors = getErrors;
var getIsUnsubscribed = (0, _ramda.compose)((0, _ramda.prop)('isUnsubscribed'), pathToProfileSettings);
exports.getIsUnsubscribed = getIsUnsubscribed;
var getCountryId = (0, _ramda.compose)((0, _ramda.prop)('countryId'), pathToProfileSettings);
exports.getCountryId = getCountryId;
var getCurrencyId = (0, _ramda.compose)((0, _ramda.prop)('currencyId'), pathToProfileSettings);
exports.getCurrencyId = getCurrencyId;
var getCalendarPeriods = (0, _ramda.compose)((0, _ramda.prop)('calendarPeriods'), pathToProfileSettings);
exports.getCalendarPeriods = getCalendarPeriods;
var getIsHideBusyPeriods = (0, _ramda.compose)((0, _ramda.prop)('hideBusyCalendarPeriods'), pathToProfileSettings);
exports.getIsHideBusyPeriods = getIsHideBusyPeriods;
var getIsAutoSendMeetingInvite = (0, _ramda.compose)((0, _ramda.prop)('autoSendMeetingInviteToRecipient'), pathToProfileSettings);
exports.getIsAutoSendMeetingInvite = getIsAutoSendMeetingInvite;
var getMeetingDuration = (0, _ramda.compose)((0, _ramda.prop)('meetingDuration'), pathToProfileSettings);
exports.getMeetingDuration = getMeetingDuration;
var getBufferTimeInMinutes = (0, _ramda.compose)((0, _ramda.prop)('bufferTimeInMinutes'), pathToProfileSettings);
exports.getBufferTimeInMinutes = getBufferTimeInMinutes;
var getMeetingFrequency = (0, _ramda.compose)((0, _ramda.prop)('meetingFrequency'), pathToProfileSettings);
exports.getMeetingFrequency = getMeetingFrequency;
var getMeetingLimits = (0, _ramda.compose)((0, _ramda.prop)('meetingLimits'), pathToProfileSettings);
exports.getMeetingLimits = getMeetingLimits;
var getMeetingPlace = (0, _ramda.compose)((0, _ramda.prop)('meetingPlace'), pathToProfileSettings);
exports.getMeetingPlace = getMeetingPlace;
var getCalendarTimezone = (0, _ramda.compose)((0, _ramda.prop)('calendarTimezone'), pathToProfileSettings);
exports.getCalendarTimezone = getCalendarTimezone;